import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DirectieCompartimenteComponent } from './directie-compartimente.component';
import { MaterialModule } from 'src/app/material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@NgModule({
    declarations: [
        DirectieCompartimenteComponent,
    ],
    imports: [
        CommonModule,
        MaterialModule,
        FormsModule,
        ReactiveFormsModule,
    ],
    exports: [DirectieCompartimenteComponent]
})
export class DirectieCompartimenteModule { }
